import { IconProps } from "./types";

export const ArrowLeftIcon = ({
  size = 18,
  color = "currentColor",
  className,
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="m12.5 16.6-5.433-5.433a1.655 1.655 0 0 1 0-2.333L12.501 3.4"
      stroke={color}
      strokeWidth="2.778"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
